// extracted by mini-css-extract-plugin
export default {"header":"GestionModuleHeader_header__sLjaC","title":"GestionModuleHeader_title__6xo1Y","backButton":"GestionModuleHeader_backButton__ofkcJ"};